var Viktory = Viktory || {};

Viktory.Webforms = Viktory.Webforms || {};

Viktory.Webforms.Submit = function() {

  var _select = {
    form :                'form.ajax-webform',
    container :           '.ajax-webform-container'
  }

  var _init = function() {
    jQuery(_select.form).each(function(){
      jQuery(this).off('submit').on('submit', _handleSubmit);
    });
  }

  var _handleSubmit = function(e) {
    // prevent form submit & disable submit button
    e.preventDefault();
    var webForm = jQuery(this);
    var submitBtn = webForm.find('button[type=submit]');
    submitBtn.attr('disabled', 'disabled').addClass('disabled');
    // get form url & data
    var url = webForm.attr('action');
    var strFormData = webForm.serialize();
    var webFormContainer = webForm.parents(_select.container);
    // post form via ajax
    jQuery.ajax({
      method: 'POST',
      url: url,
      data: strFormData,
      success: function(response) {
        var gtmEventData = webForm.data('gtmevdata');
        jQuery(webFormContainer).html(response.html);
        if (response.result === 'fail') {
          // reattach form submit handler
          _init();
          // broadcast failed event
          jQuery.publish('Viktory.Webforms.Submit.fail');
        } else if (response.result === 'success') {
          // broadcast success event
          jQuery.publish('Viktory.Webforms.Submit.success');
          // send google analytics event via gtm
          ValueJS.GTM.Events.track(gtmEventData);
        }
      }
    });
  }

  /** PUBLIC API **/
  return {
    init : function() {return _init();},
  };

}();

jQuery(document).ready(function() {
  Viktory.Webforms.Submit.init();
});
